import React from "react";
import './styles.scss';

/**
 * props.versions: white | disabled | transparent
 * props.size: default | md | sm
 */

const Button = (props) => {
    const Icon = props.icon;
    return (
        <button
            className={`button ${props.className} ${props.version ? props.version : ''}  ${props.size ? props.size : ''}
            ${props.role !== null ? '' : 'disabled'}`}
            onClick={props.onClick} type="submit"
        >
            {props.label} {Icon && <Icon/>}
        </button>
    )
};

export default Button;
